import { useNotification } from '../../provider/ToastNotificationProvider';
import { postMessageToRN } from '../../utils/RNCommunicator/postMessageToRN.util';
import { usePostVirtualNumberMutation } from '../api/virtual-number/mutations/usePostVirtualNumber.mutation';
import { useAppDispatch } from '../store/useStore';
import { virtualNumberLoadingSlice } from '../../store/virtualNumberLoadingSlice';

interface IUseVirtualNumberInquiryParams {
  productId: string;
  productCode: string;
  sellerPhoneNumber: string;
}

interface IUseVirtualNumberInquiryReturn {
  callWithVirtualNumber: () => void;
  isLoading: boolean;
}

export const useVirtualNumberInquiry = ({
  productId,
  productCode,
  sellerPhoneNumber,
}: IUseVirtualNumberInquiryParams): IUseVirtualNumberInquiryReturn => {
  const dispatch = useAppDispatch();
  const virtualNumberLoadingActions = virtualNumberLoadingSlice.actions;
  const { openNotification } = useNotification();
  const { mutate: postVirtualNumber, isLoading } = usePostVirtualNumberMutation();

  const callWithVirtualNumber = () => {
    if (!sellerPhoneNumber) {
      openNotification({
        message: '판매자 전화번호 정보가 없습니다.',
        type: 'error',
      });
      return;
    }

    const isProduction = process.env.REACT_APP_CLIENT_ENVIRONMENT === 'production';

    // 운영 환경이 아니면 실제 번호로 바로 전화
    if (!isProduction) {
      if (window.ReactNativeWebView) {
        postMessageToRN({ messageKey: 'link', messageParam: `tel:${sellerPhoneNumber}` });
      } else {
        window.location.href = `tel:${sellerPhoneNumber}`;
      }
      return;
    }

    // 운영 환경에서만 안심번호 발급
    // 전역 로딩 시작
    dispatch(virtualNumberLoadingActions.setVirtualNumberLoading(true));

    // 안심번호 발급 API 호출 (판매자의 실제 전화번호를 전달)
    postVirtualNumber(
      {
        productId,
        productCode,
        realNumber: sellerPhoneNumber,
      },
      {
        onSuccess: (data) => {
          // 전역 로딩 종료
          dispatch(virtualNumberLoadingActions.setVirtualNumberLoading(false));

          // 발급받은 안심번호로 전화 걸기
          if (window.ReactNativeWebView) {
            postMessageToRN({ messageKey: 'link', messageParam: `tel:${data.virtualNumber}` });
          } else {
            window.location.href = `tel:${data.virtualNumber}`;
          }
        },
        onError: (error) => {
          // 전역 로딩 종료
          dispatch(virtualNumberLoadingActions.setVirtualNumberLoading(false));

          // 안심번호 발급 실패 시 알림
          openNotification({
            message: '안심번호 발급에 실패했습니다. 잠시 후 다시 시도해주세요.',
            type: 'error',
          });
          console.error('안심번호 발급 실패:', error);
        },
      },
    );
  };

  return {
    callWithVirtualNumber,
    isLoading,
  };
};
